import firebase from "./firebase";
import "firebase/compat/auth";

// Return the auth instance from the already initialized app
export default () => {
  try {
    // Force refresh token on each auth check to ensure fresh credentials
    const currentUser = firebase.auth().currentUser;
    if (currentUser) {
      currentUser.getIdToken(true).catch((err) => {
        console.error("Error refreshing token:", err);
        // If token refresh fails, sign out to force re-auth on next request
        firebase.auth().signOut().catch(console.error);
      });
    }
    return firebase.auth();
  } catch (error) {
    console.error("Error accessing Firebase auth:", error);
    throw error;
  }
};
